export default __webpack_public_path__ + "static/media/duration-icon.f7f36948.svg";